'use client';

import { c as _c } from "react/compiler-runtime";
import SvgBenefitFill from '@common/icon/SvgBenefitFill';
import SvgLocationHeartFill from '@common/icon/SvgLocationHeartFill';
import SvgMyFill from '@common/icon/SvgMyFill';
import type { FloatingBnbItem } from '@/app/_components/FloatingBnbController/_components/FloatingBnb';
import { FloatingBnb } from '@/app/_components/FloatingBnbController/_components/FloatingBnb';
import { DONATION_ROUTES, ROUTES } from '@/constants';
import { PolicyPlusIcon } from './PolicyPlusIcon';

//* 연말 이벤트 한정 — 되돌리는 절차는 src/plans/WEL-5478-donation-home-entry.md
const GOODS_DONATION_BNB_ITEMS: readonly FloatingBnbItem[] = [{
  label: '홈',
  pathname: DONATION_ROUTES.HOME.pathname,
  //* 웰로 채널은 메인홈 주소에 고기부홈이 rewrite돼 있어 같은 화면을 두 주소로 쌓지 않는다
  href: ROUTES.HOME.pathname,
  icon: SvgLocationHeartFill
}, {
  label: '정책+',
  pathname: ROUTES.FEED.pathname,
  icon: PolicyPlusIcon
}, {
  label: '혜택',
  pathname: ROUTES.BENEFIT.pathname,
  icon: SvgBenefitFill
},
//* 웰로 웹·앱 채널 전용 BNB라 마이는 고기부 화면에서도 웰로 마이페이지로 보낸다
{
  label: '마이',
  pathname: ROUTES.MY.pathname,
  icon: SvgMyFill
}];
export const GoodsDonationBnb = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FloatingBnb items={GOODS_DONATION_BNB_ITEMS} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};